module.exports = __webpack_public_path__ + "static/media/svgIcons.sprite.18d19a9b.svg";